import AutoInfoTab from './AutoInfo';
import DriversTab from './Drivers';
import InsuranceHistoryTab from './InsuranceHistory';

export {
  DriversTab,
  AutoInfoTab,
  InsuranceHistoryTab,
};
